import './ProjectListRating.scss';
import { HvacResultsRating } from '@belimo-retrofit-portal/logic';
import React from 'react';
import { EnergyEfficiencyLabelWrapper } from 'src/modules/common/components/EnergyEfficiencyLabelWrapper';
import { ChevronRightIcon } from 'src/modules/common/icons/ChevronRightIcon';

type Props = {
  readonly rating: HvacResultsRating;
};

export const ProjectListRating = ({ rating }: Props): React.ReactElement => (
  <div className="bp-project-list-rating">
    <EnergyEfficiencyLabelWrapper value={rating.actual} disabled={false} size="md" fixed={true}/>

    <div className="bp-project-list-rating__icon">
      <ChevronRightIcon/>
    </div>

    <EnergyEfficiencyLabelWrapper value={rating.future} disabled={false} size="md" fixed={true}/>
  </div>
);
